<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">新建通知公告</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回</a>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="140px" class="form">
          <el-form-item label="标题">
            <el-input size="small" placeholder="请输入通知标题" v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item label="通知内容">
            <el-input type="textarea" placeholder="请输入通知内容" :autosize="{ minRows: 6, maxRows: 10}" size="small"
              v-model="form.content"></el-input>
          </el-form-item>
          <el-form-item label="权限设置">
            <div class="tip" style="padding:5px 0;">* 不设置权限：默认所有人均能查看</div>
            <div class="dep-auth">
              <div class="contact-user-list">
                <div class="user-item" v-for="user,j in depArr">
                  <span class="name">{{user.name}}</span>
                  <!-- <span @click="deleteDeps(j)" class="iconfont icon-close1"></span> -->
                </div>
              </div>
              <el-button type="primary" @click="addDeps()" size="mini" icon="el-icon-plus">设置公司/部门权限</el-button>
            </div>
            <div class="user-auth">
              <div class="contact-user-list">
                <div class="user-item" v-for="user,j in selectArr">
                  <span class="name">{{user.name}}</span>
                  <span @click="deleteUsers(j)" class="iconfont icon-close1"></span>
                </div>
              </div>
              <el-button @click="addUsers()" type="primary" size="mini" icon="el-icon-plus">设置人员权限</el-button>
            </div>
          </el-form-item>

          <div class="tip" style="margin:20px 0 0 40px">
            * 相关附件
          </div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments style="margin-left:-15px;" :projectId="form.projectId" :contractId="form.contractId"
                ref="attachments" :arr="attachmentArr" :type='990'></attachments>
            </el-form-item>
          </div>

          <el-form-item label="">
            <div class="form-btn-room">
              <el-button :loading="formLoading" @click="createNotice()" class="form-btn" type="success">提交通知公告
              </el-button>
              <el-button @click="$router.back()" v-if="form.applyId" type="info" plain>取消修改</el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-col>
    </div>


    <!-- 选择公司/部门 -->
    <div class="pop-room asset-type-pop" v-if="organizationListStatus">
      <a href="javascript:;" @click="organizationListStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-tree style="max-height:400px;overflow-y:auto;" :data="organizationList" show-checkbox
            :props="organizationProps" node-key="id" ref="organizationTree">
          </el-tree>
          <el-button size="mini" @click="organizationSelectSuccess()" type="primary" style="margin:15px 0 0 25px;">确认选择
          </el-button>
        </el-col>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import Attachments from '@/components/Attachments'
  export default {
    components: {
      Attachments,
    },
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        contactSelectArr: state => state.main.contactSelectArr,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        organizationListData: [],
        noSelectOrganization: true,

        form: {
          title: "",
          content: "",
          depIds: "",
          userIds: "",
        },
        // 设置人员权限
        selectArrIndex: "",
        selectArr: [],

        // 设置部门权限
        depArrIndex: "",
        depArr: [],
        organizationListStatus: false,
        organizationList: [],
        organizationProps: {
          children: 'childDepts',
          label: 'name'
        },
        organizationCheck: {},

        // 附件
        attachmentArr: [],
        formLoading: false,
      }
    },
    created() {
      this.form.noticeId = this.$route.params.id
      if (this.form.noticeId) {
        ajax.get('/notice/info/' + this.form.noticeId, '', (res) => {
          this.form = res.vo
          this.attachmentArr = this.form.attachments ? this.form.attachments : []
          this.form.noticeId = this.$route.params.id
          this.depArr = this.form.departments
          this.selectArr = this.form.users
        })
      }
    },
    mounted() {
      this.organizationList = this.organization[0].childDepts


    },
    methods: {
      // 设置人员权限
      addUsers() {
        let _sr = []
        _sr = this.selectArr ? this.selectArr : []
        this.$store.commit('set_contactSelectArr', _sr)
        this.$store.commit('set_contactShow', true)
        this.$store.commit('set_contactSingleSelect', false)
      },
      deleteUsers(index) {
        this.selectArr.splice(index, 1)
      },
      // 设置部门
      addDeps() {
        this.organizationListStatus = true
        if (this.depArr) {
          this.$nextTick(() => {
            this.$refs.organizationTree.setCheckedNodes(this.depArr)
          })
        }
      },
      // 确认选择公司/部门
      organizationSelectSuccess() {
        this.organizationListStatus = false
        this.depArr = this.$refs.organizationTree.getCheckedNodes()
      },
      deleteDeps(index) {
        this.depArr.splice(index, 1)
      },

      // 创建通知公告
      createNotice() {
        if (this.selectArr) {
          this.form.userIds = this.selectArr.map(item => item.id).join()
        }
        if (this.depArr) {
          this.form.depIds = this.depArr.map(item => item.id).join()
        }

        if (!this.form.title || !this.form.content) {
          this.$message.error('新建通知公告必须填写标题和内容')
          return
        }

        this.form.attachments = this.$refs.attachments.getAttachments()

        this.formLoading = true
        let _url = this.form.noticeId ? '/notice/edit' : '/notice/add'
        ajax.post(_url, this.form, (res) => {
          this.formLoading = false
          this.$message.success("新建通知公告成功")
          this.$router.push('/Notice/List')
        }, () => {
          this.formLoading = false
        })
      },
    },
    watch: {
      contactSelectArr() {
        this.selectArr = this.contactSelectArr
        // console.log(this.contactSelectArr)
        // this.$set(this.selectArr, this.selectArrIndex, this.contactSelectArr)
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/page/notice/create.vue